// apiService.js
import { API_PASSWORD } from '../config';
import { getSubdomain, fetchWithAuth } from '../helpers';
import { getToken } from '../helpers';

export const fetchSettings = async () => {
  
  const subdomain = getSubdomain();
  const token = localStorage.getItem("token");
  const url = `https://${subdomain}.restocash.app/api/get/settings?api_password=Project102$_`;

  const response = await fetch(url, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  const data = await response.json();

  if (!response.ok) {
    
    throw new Error(data.message || "❌ فشل في جلب إعدادات الخدمات والضرائب.");
  }

  console.log("🔥 البيانات:", data);
  return data.data?.settings?.[0] || {};

};

// تعديل خيار الطباعة بعد الحفظ (print_invoice_after_saving)
// value متوقع '0' أو '1' أو رقم/boolean قابل للتحويل
export const editPrintInvoiceAfterSaving = async (value) => {
	const subdomain = getSubdomain();
	const url = `https://${subdomain}.restocash.app/api/edite/print/invoice/after/saving?api_password=Project102$_`;
	const token = localStorage.getItem("token");

	const formData = new FormData();
	formData.append("print_invoice_after_saving", String(value));

	const response = await fetch(url, {
		method: "POST",
		headers: {
			Authorization: `Bearer ${token}`,
			// لا تضف Content-Type لأن المتصفح يحدده تلقائياً عند استخدام FormData
		},
		body: formData,
	});

	const data = await response.json();

	if (!response.ok) {
		throw new Error(data.message || "❌ فشل في تعديل خيار الطباعة بعد الحفظ.");
	}

	return data;
};

// إضافة دالة تعديل طريقة الطباعة (printing_method)
// method متوقع نص مثل 'automatic' أو 'manuel'
export const editPrintingMethod = async (method) => {
	const subdomain = getSubdomain();
	const url = `https://${subdomain}.restocash.app/api/edite/printing/method?api_password=Project102$_`;
	const token = localStorage.getItem("token");

	const formData = new FormData();
	formData.append("printing_method", String(method));

	const response = await fetch(url, {
		method: "POST",
		headers: {
			Authorization: `Bearer ${token}`,
			// لا تضف Content-Type لأن المتصفح يحدده تلقائياً عند استخدام FormData
		},
		body: formData,
	});

	const data = await response.json();

	if (!response.ok) {
		throw new Error(data.message || "❌ فشل في تعديل طريقة الطباعة.");
	}

	return data;
};

// تعديل رقم طباعة الأوردر قبل النهاية (order_print_number)
// value متوقع رقم أو نص يمثل العدد (مثال: 10)
export const editOrderPrintNumber = async (value) => {
	const subdomain = getSubdomain();
	const url = `https://${subdomain}.restocash.app/api/edite/order/print/number?api_password=Project102$_`;
	const token = localStorage.getItem("token");

	const formData = new FormData();
	formData.append("order_print_number", String(value));

	const response = await fetch(url, {
		method: "POST",
		headers: {
			Authorization: `Bearer ${token}`,
			// لا تضف Content-Type — المتصفح يحدده تلقائياً مع FormData
		},
		body: formData,
	});

	const data = await response.json();

	if (!response.ok) {
		throw new Error(data.message || "❌ فشل في تعديل رقم طباعة الأوردر.");
	}

	return data;
};

// تعديل خيار تنبيه زمن التحضير (preparation_time_alert)
// value متوقع '0' أو '1' أو قيمة قابلة للتحويل
export const editPreparationTimeAlert = async (value) => {
	const subdomain = getSubdomain();
	const url = `https://${subdomain}.restocash.app/api/edite/reservatio/time/alert?api_password=Project102$_`;
	const token = localStorage.getItem("token");

	const formData = new FormData();
	formData.append("preparation_time_alert", String(value));

	const response = await fetch(url, {
		method: "POST",
		headers: {
			Authorization: `Bearer ${token}`,
			// لا تضف Content-Type لأن المتصفح يحدده تلقائياً عند استخدام FormData
		},
		body: formData,
	});

	const data = await response.json();

	if (!response.ok) {
		throw new Error(data.message || "❌ فشل في تعديل إعداد تنبيه زمن التحضير.");
	}

	return data;
};

// تعديل خيار زر التحضير للصراف (preparation_casher_button)
// value متوقع '0' أو '1' أو أي قيمة قابلة للتحويل إلى نص
export const editPreparationCasherButton = async (value) => {
	const subdomain = getSubdomain();
	const url = `https://${subdomain}.restocash.app/api/edite/preparation/casher/button?api_password=Project102$_`;
	const token = localStorage.getItem("token");

	const formData = new FormData();
	formData.append("preparation_casher_button", String(value));

	const response = await fetch(url, {
		method: "POST",
		headers: {
			Authorization: `Bearer ${token}`,
			// لا تضف Content-Type لأن المتصفح يحدده تلقائياً عند استخدام FormData
		},
		body: formData,
	});

	const data = await response.json();

	if (!response.ok) {
		throw new Error(data.message || "❌ فشل في تعديل خيار زر التحضير للصراف.");
	}

	return data;
};

// جلب عدد مرات الطباعة للأوردَر (count print order)
// id متوقع رقم أو معرف ذات صلة (مثال: 2) — غيّر المسار إن كان الAPI يتوقع باراميتر آخر
export const getCountPrintOrder = async (id) => {
	const subdomain = getSubdomain();
	const token = localStorage.getItem('token');

	// إذا كان id غير مطلوب، يمكنك تمرير null وسيُستخدم المسار بدون معرف
	const path = id ? `/api/count/print/order/${id}` : '/api/count/print/order';
	const url = `https://${subdomain}.restocash.app${path}?api_password=Project102$_`;

	const response = await fetch(url, {
		method: 'GET',
		headers: {
			Authorization: `Bearer ${token}`,
		},
	});

	const data = await response.json();

	if (!response.ok) {
		// اذا كانت الرسالة فارغة استخدم نص افتراضي
		throw new Error(data?.message || '❌ فشل في جلب عدّ الطباعة للأوردَر.');
	}

	// عادة تكون البيانات في data.data — رجّع الشكل المتوفر
	return data.data ?? data;
};

